import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { User } from 'Douleutaras/types';
import { isDevelopment, isProduction } from 'Douleutaras/constants/system';
import { ignoreErrors } from 'Douleutaras/configuration/Sentry';

export const initializeLogging = ({ user }: { user: User }) =>
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    enabled: !isDevelopment,
    ignoreErrors,
    // Called for message and error events
    beforeSend: (event, hint) => {
      // Example:
      // const error = hint.originalException as ErrorEvent;
      // if (
      //   error &&
      //   error.message &&
      //   error.message.match(/database unavailable/i)
      // ) {
      //   event.fingerprint = ['database-unavailable'];
      // }

      return event;
    },
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracesSampleRate: isProduction ? 0.1 : 1.0,
    environment: process.env.REAL_ENV || 'local',
    normalizeDepth: 10,
    release: process.env.CI_COMMIT_SHORT_SHA,
    initialScope: {
      // @ts-ignore
      user: { ...user, username: undefined } // Since user is boolean on our side, sentry does not accept it
    }
  });
